export default "__VITE_ASSET__7456204f__"